var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-patientHistory","title":"History","size":"lg","hide-footer":""}},[_c('patient-history-table',{attrs:{"isRescueNet":_vm.isRescueNet}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }